import React from "react";
import Layout from "../components/Layout";
import Seo from "../components/Seo";
import PageHero from "../components/PageHero";
import SectionHeading from "../components/SectionHeading";
import LocationBand from "../components/LocationBand";
import CtaBand from "../components/CtaBand";
import { useSite } from "../theme/ThemeProvider";

const VALUES = [
  { title: "Gerekmeyen parça değişmez", text: "Yapılacak işi ve fiyatını baştan söyleriz." },
  { title: "Orijinal görünüme sadık kalırız", text: "Tesisat göze batmaz; araç içine girilmemiş gibi teslim edilir." },
  { title: "Standart dışına çıkmayız", text: "ECE R67'ye uygun montaj, belgeli teslim." },
  { title: "Söz verdiğimiz saatte teslim", text: "Aracınızı serviste günlerce bekletmeyiz." },
  { title: "Ulaşılabiliriz", text: "Yol üzerindeyiz; bir sorun olursa aynı gün bakarız." },
];

const About = () => {
  const site = useSite();
  return (
    <Layout>
      <Seo
        title="Hakkımızda – 40 Yıl Otomotiv, 30 Yıl Otogaz"
        description="Mahir Zirh 40 yılı aşkın süredir otomotivde, 30 yıldır LPG dönüşüm ve araç servisi yapıyor. İstanbul'daki başarılı yılların ardından Yalova Altınova Kaytazdere'deki atölyemizde hizmete devam ediyoruz."
        path="/hakkimizda"
      />
      <PageHero
        title="Hakkımızda"
        text="İstanbul'da başarıyla sürdürdüğümüz 30 yılın ardından, Kaytazdere'deki iş yerimizde çalışma hayatımıza devam ediyoruz."
        crumbs={[{ label: "Hakkımızda" }]}
      />

      <section className="section">
        <div className="container">
          <div className="split">
            <figure className="split__media">
              <img src={site.founder.photo} alt={site.founder.name} style={{ aspectRatio: "1 / 1" }} />
              <figcaption>{site.founder.name}, atölyede.</figcaption>
            </figure>
            <div>
              <SectionHeading title={site.founder.name} text={site.founder.title} />
              <p>
                Kırk yılı aşkın süredir sanayideyim. İşe oto elektrik ustası olarak başladım, otogaza otuz yıl önce
                geçtim. O günden beri yaptığım tek iş bu. İstanbul'daki atölyemde otuz yıl boyunca LPG montajı, tank
                değişimi ve bakım yaptım; kaç araç geçti saymadım ama çoğunun sahibini hâlâ tanırım.
              </p>
              <p>
                On beş yılı aşkın süredir Atiker yetkili servisiyim. Zavoli, Lovato ve BRC dahil piyasadaki hemen her
                sistemi taktım; marka fark etmeksizin bakımını ve tamirini yaparım.
              </p>
              <p>
                Montajda aracın görüntüsüne dikkat ederim. Tesisatı göze batmayacak şekilde çeker, orijinaline
                mümkün olduğunca dokunmam. Araç atölyeden çıktığında içine girildiği belli olmaz.
              </p>
              <p>
                Şimdi aynı işi Yalova Altınova'da, Kaytazdere'deki yeni atölyemde yapıyorum. Yöntem aynı: aracı önce
                inceler, ne yapılacağını ve kaça mal olacağını baştan söylerim. Montaj bitince 22 noktadan kontrol
                eder, yol testi yapar, öyle teslim ederim.
              </p>
              <p>
                Yeni yerle birlikte motor yağı değişimi ve çeki demiri montajını da ekledik. Sorunuz olursa arayın;
                telefona kendim bakıyorum.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section section--surface" style={{ borderTop: "1px solid var(--color-border)", borderBottom: "1px solid var(--color-border)" }}>
        <div className="container">
          <div className="split split--reverse" style={{ alignItems: "start" }}>
            <div>
              <SectionHeading title="Kısaca" />
              <div className="timeline">
                <div className="timeline__item">
                  <h4>1980'ler</h4>
                  <p>Sanayide otomotive başladı. İlk işi oto elektrik.</p>
                </div>
                <div className="timeline__item">
                  <h4>1990'lar</h4>
                  <p>Otogaza geçiş. LPG asıl iş oldu.</p>
                </div>
                <div className="timeline__item">
                  <h4>2010'lar</h4>
                  <p>Atiker yetkili servisi. 3 aşama 22 nokta kontrol listesi bu dönemde oturdu.</p>
                </div>
                <div className="timeline__item">
                  <h4>2026</h4>
                  <p>Kaytazdere'ye taşındık. Motor yağı değişimi ve çeki demiri montajı eklendi.</p>
                </div>
              </div>
            </div>
            <div>
              <SectionHeading title="Nelere dikkat ederiz" />
              <ul className="plain-list">
                {VALUES.map((v) => (
                  <li key={v.title}>
                    <span>
                      <strong>{v.title}.</strong> {v.text}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      <LocationBand />
      <CtaBand title="Uğrayın ya da arayın" text="Aracınızla gelin, birlikte bakalım. Fiyat için marka ve modeli yazmanız yeterli." />
    </Layout>
  );
};

export default About;
